export enum UploadStatus {
  New = 'Added to queue',
  Pending = 'Waiting in queue',
  InProgress = 'Currently uploading',
  Succeed = 'Successfully uploaded',
  Canceled = 'Canceled by the user',
  Failed = 'Uploading failed',
}
